import {useEffect,useState,useRef} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {
	setInReferenceToResource,
	selectInReferenceToResource,
	deleteChatRoomMessage,
	reactToChatMessage,
	removeMembersFromChatRoom,
	updateChatRoomName,
	addMembersToChatRoom,
	createChatMessage,
	loadMoreMessages,
	selectOtherRoomMembers,
	selectActiveRoom,
	toggleSaveMemo,
	deleteChatRoom,
	scheduleMessage,
	selectContacts,
	selectShow as selectShowMessageCenter
} from '../messageCenterSlice'
import Select from "react-select"
import CenteredLoader from '../../CenteredLoader/CenteredLoader'
import FileButton from '../../FileButton/FileButton'
import {capitalize,dateToAPIStandard,resourceTypeDisplayText} from '../../../util/util'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import useS3DirectUpload from '../../../hooks/useS3DirectUpload'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import styles from './ActiveRoom.module.css'
import EmojiPicker from 'emoji-picker-react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import Tooltip from 'react-bootstrap/Tooltip'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import Linkify from 'react-linkify'
import moment from 'moment'
import ContactSelector from '../ContactSelector/ContactSelector'
import MemoRecorder from '../../MemoRecorder/MemoRecorder'
import {toggleShow as toggleShowMemoRecorder} from '../../MemoRecorder/slice'
import Reactions,{checkHasReactions} from '../../reactions/Reactions'
import ResourceReference from '../ResourceReference/ResourceReference'

const linkDecorator = (href, text, key) => (
  <a href={href} key={key} target="_blank" rel="noopener noreferrer">
    {text}
  </a>
)

const LoadMoreMessages = ({setIsLoadingMore,room_id,variant})=>{
	const dispatch = useDispatch()
	const user_id_number = useSelector(state=>state.users.current_user.user_id_number)
	//we we should already have loaded the first 50
	//so set the limit to 100
	const [limit,setLimit] = useState(100)
	const [status,setStatus] = useState('idle')
	const [noMoreMessages,setNoMoreMessages] = useState(false)
	const handleLoadMore = ()=>{
		setStatus('pending')
		setIsLoadingMore(true)
		dispatch(loadMoreMessages({
			room_id,
			limit
		})).then(action=>{
			setNoMoreMessages(action.payload.data.chat_room.messages.length < limit)
			setStatus('idle')
			setIsLoadingMore(false)
		})
		setLimit(limit+50)
	}
	return (
		noMoreMessages?
		<div className="text-center mb-2">
			All messages loaded
		</div>
		:
		<Button 
			disabled={status==='pending'}
			variant={variant}
			onClick={handleLoadMore}
			className="mb-2" 
			block
		>
			{
				status === 'pending' ?
				<Spinner animation="border" size="sm"/>:
				"Load More"
			}
		</Button>
	)
}

const newTimeInRange = ( prevTime, newTime, range = 30 ) => {
	const diff = moment(newTime).diff(moment(prevTime),'minutes',true)
	const timeInRange = diff <= range
	return  timeInRange
}

const Members = ()=>{
	const statusDispatch = useApiStatusDispatch()
	const [status,setStatus] = useState('idle')
	const [open,setOpen] = useState(false)
	
	const [membersToRemove,setMembersToRemove] = useState([])
	const user = useSelector(state=>state.users.current_user)
	const {
		id,
		owner_id,
		members_map,
		shared,
		other,
		others,
		name:roomName
	} = useSelector(selectActiveRoom)
	const [newRoomName,setNewRoomName] = useState(roomName)
	const {byType:contactsByType} = useSelector(selectContacts)
	const isOwner = parseInt(owner_id) === parseInt(user.user_id_number)
	const isClient = user.account_type === 'client'
	const owner = members_map[owner_id]
	const members = Object.values(members_map).filter(
		member => member.user_id_number!=user.user_id_number
	)
	const handleToggleRemoveMember = id => {
		if( membersToRemove.includes(id) ){
			setMembersToRemove(membersToRemove.filter( m => m!==id ))
		} else {
			setMembersToRemove([id,...membersToRemove])
		}
	}

	const handleRemoveMembers = ()=>{
		setStatus('pending')
		statusDispatch(
			removeMembersFromChatRoom({
				group_ids:membersToRemove,
				room_id:id
			}),
			'chat room members',
			'delete'
		).then(()=>{
			setStatus('idle')
			setMembersToRemove([])
		})
	}

	const handleUpdateName = ()=>{
		statusDispatch(
			updateChatRoomName({room_id:id,name:newRoomName}),
			'chat room name',
			'edit'
		)
	}

	const handleAddMembers = (selectedContacts)=>{
		//selectedContacts comes from react select 
		//so map to array of user_id_numbers
		const membersToAdd = selectedContacts.map(c=>c.value)
		//needs to return a promise
		return statusDispatch(
			addMembersToChatRoom({
				group_ids:membersToAdd,
				room_id:id
			}),
			'chat room members',
			'add'
		)
	}

	const handleDeleteChatRoom = ()=>{
		if(!window.confirm('Are you sure?')) return
		statusDispatch(deleteChatRoom({room_id:id}),'chat room','delete')
	}

	if(owner_id === 0) return (
		<div className={styles.MembersContainer}>
			<div className={styles.Members}>
				<OverlayTrigger overlay={
					<Tooltip>Private Chat rooms cannot be edited</Tooltip>
				}>
					<div className={styles.MembersHeader}>
						{ 
							shared ?
							(
								isClient ?
								(
									others.length > 1 ?
									'Chatting with trainers' :
									`Chatting with ${members_map[others[0]].user_name}`
								)
								:
								`Chatting with ${other.user_name} (shared)`
							)
							:
							`Chatting with ${other.user_name}`
						}
					</div>
				</OverlayTrigger>
			</div>
		</div>
	)
	return (
		<div 
			onClick={()=>{setOpen(!open)}}
			className={[
				styles.MembersContainer,
				open&&styles.Open
			].join(' ')}
		>
			<div 
				className={[
					styles.Members,
					open&&styles.Open
				].join(' ')}
			>
				<div className={styles.MembersHeader} style={{cursor:'pointer'}}>
					{isOwner&&<i className="fa fa-cog mr-1 text-primary"/>}
					{isOwner?'Edit':'View'}{ Boolean(roomName) ? ` ${roomName} ` : ' chat room members ' }({members.length})
				</div>
				<div 
					className={styles.MembersList}
					onClick={e=>{
						if(open)e.stopPropagation()
					}}
				>
					{isOwner&&
						<div>
							<small>Edit room name:</small>
							<div className="d-flex">
								<Form.Control 
									className="mr-1"
									onChange={e=>{
										setNewRoomName(e.target.value)
									}}
									placeholder="room name" 
									value={newRoomName}
									size="sm"
								/>
								<Button 
									onClick={handleUpdateName}
									variant="outline-success" 
									size="sm"
								>
									Update
								</Button>
							</div>
							<hr/>
						</div>
					}
					{isOwner&&
						<ContactSelector
							heading="Add members"
							maxMenuHeight={200}
							completeText="Add"
							cancelText="cancel"
							onCancel={()=>{}}
							onComplete={handleAddMembers}
							exclude={members.map(m=>m.user_id_number)}
						/>
					}
					{members.map( member => (
						<div className={styles.Member}>
							{isOwner&&
								<button 
									disabled={status==='pending'}
									className={[
										membersToRemove.includes(member.user_id_number)&&styles.Active,
										styles.RemoveMember,
										"fa fa-times"
									].join(' ')}
									onClick={()=>{
										handleToggleRemoveMember(member.user_id_number)
									}}
								/>
							}
							{member.user_name}
						</div>
					))}
					{
						isOwner?
						(membersToRemove.length>0&&
							<Button 
								disabled={membersToRemove.length===0||status==='pending'}
								onClick={handleRemoveMembers}
								variant="outline-danger" 
								className="my-1"
								size="sm" 
								block
							>
								{
									status==='pending'?
									<Spinner animation="border" size="sm"/>:
									"Remove Members"
								}
							</Button>
						)
						:
						<div className="text-center mb-1">
							<small>This room belongs to {owner.user_name}</small>
						</div>
					}
					{isOwner&&
						<div className="text-right">
							<Button 
								onClick={handleDeleteChatRoom} 
								className="text-danger" 
								variant="link"
								size="sm"
							>
								Delete this chat room
							</Button>
						</div>
					}
				</div>
			</div>
		</div>
	)
}

const Timer = ({ seconds, onEnd }) => {
  // initialize timeLeft with the seconds prop
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    // exit early when we reach 0
    if (!timeLeft){ 
    	onEnd()
    	return
    };

    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
    // add timeLeft as a dependency to re-rerun the effect
    // when we update it
  }, [timeLeft]);
  return (
    <div>time left: {timeLeft}</div>
  );
};

//!!! need to use global scope for these !!!
let mediaStream = false
let mediaRecorder = false
const Recorder = ({handleClose}) => {
	const dispatch = useDispatch()
	const user = useSelector(state=>state.users.current_user)
	const {id} = useSelector(selectActiveRoom)
	const [status,setStatus] = useState('idle')
	const [recording,setRecording] = useState(false)
	const [chunks,setChunks] = useState([])
	const [showPreview,setShowPreview] = useState(false)

	//use a ref for the message text area so that typing
	//does not cause a re-render to other components
	const textareaRef = useRef()

	//set up the media recording on render
	const handleRecording = async ()=>{
		if(!recording){
			setStatus('pending')
			setRecording(true)		
			mediaRecorder = await new MediaRecorder(mediaStream)
			mediaRecorder.onstart = ()=>{
				setStatus('idle')
			}
			mediaRecorder.ondataavailable = e => {
				setChunks( prev => [...prev,e.data] )
			}
			mediaRecorder.start()
			
		}else{
			setRecording(false)	
			mediaRecorder.stop()
			setShowPreview(true)
		}
	}

	const handleClear = ()=>{
		setChunks([])
		setShowPreview(false)
	}

	const reactionsMap = useSelector(state=>state.reactions.entities)
	const handleSend = async ()=>{
		const reactionsWithCount = {}
		Object.entries(reactionsMap).forEach(([k,v])=>{
			reactionsWithCount[k] = {...v,count:0}
		})
		setStatus('pending')
		const mimeType = chunks[0].type.split(';')[0]
		const mediaType = mimeType.split('/')[0]
		const extension = mimeType.split('/')[1]
		const memoBlob = new Blob(chunks, { type : mimeType })
		const memoFile = await new File([memoBlob],`memo.${extension}`)
		if(memoFile){
			setStatus('idle')
			dispatch(createChatMessage({
				media_type_id:mediaType === 'audio' ? 4 : 1,
				attachment:URL.createObjectURL(memoBlob),
				message:textareaRef.current.value,
				author_id:user.user_id_number,
				transcode_memo_to_mp4:1,
				media_type:mediaType,
				memo:memoFile,
				room_id:id,
				is_memo:1,
				reactions:{
					author_reaction_id:0,
					map:reactionsMap
				}
			}))
		}
		handleClose()
		setChunks([])
		setShowPreview(false)
	}

	useEffect(()=>{
		return ()=>{
			mediaStream.getTracks().forEach( track => {
				track.stop()
			})
		}
	},[])

	return (
		<div 
			onClick={handleClose}
			className={[styles.Recorder,"border shadow"].join(' ')}
		>
			<div onClick={e=>{e.stopPropagation()}}>
				{
					( !showPreview || !chunks.length ) ?
					<div className="my-2 text-center px-4">
						<Button 
							disabled={status==='pending'}
							onClick={handleRecording}
							block
							variant={
								recording ? 
								"outline-danger" : 
								"outline-dark"
							}
						>
							{recording?'Stop':'Start'} recording <i className="fas fa-circle"/>
						</Button>
						{recording&&
							<Timer onEnd={handleRecording} seconds={60}/>
						}
					</div>
					:
					<div className="d-flex align-items-center flex-column">
						<div><strong>Preview</strong></div>
						{
							<video style={{width:'80%',display:'block',margin:'auto'}} controls>
								<source 
									src={window.URL.createObjectURL(new Blob(chunks, { 'type' : chunks[0].type }))}
								/>
							</video>
						}
						<div><small>Add a message to your memo</small></div>
						<Form.Control 
							placeholder="message"
							ref={textareaRef}
							as="textarea"
						/>
						<div className="mt-3 text-center">
							<Button 
								disabled={status === 'pending'}
								variant="outline-danger"
								onClick={handleClear}
								className="px-4"
								size="sm"
							>
								Clear
							</Button>
							<Button 
								disabled={status === 'pending'}
								variant="outline-success"
								onClick={handleSend}
								className="ml-1 px-4"
								size="sm"
							>
								{
									status === 'pending' ? 
									<Spinner animation="border" size="sm" /> : 
									'Send' 
								}
							</Button>
						</div>
					</div>
				}
				<div className="text-center">
					<small>
						<i className="fa fa-info-circle mr-1"/>
						{
							(!recording&&!chunks.length)?
							'Before sending you\'ll be able to review your recording':
							'Note: memos expire 1 week after sending.'
						}
					</small>
				</div>
			</div>
		</div>
	)
}

const Attachment = ({src,mediaType,removed}) => {
	if(removed) return (
		<div className={styles.Attachment}>
			<strong>
				<i className={[
					'mr-1',
					mediaType === 'video' ? "fas fa-video-slash" : "fas fa-microphone-slash"
				].join(' ')}/>
				Expired {mediaType} memo
			</strong>
		</div>
	)
	switch(mediaType){
		case 'image': return (
			<a href={src} target="_blank">
				<img className={styles.Attachment} src={src} />
			</a>
		)
		case 'audio': return (
			<div className={styles.Attachment}>
				<div>
					<small className="d-block">Voice memo</small>
					<audio title="voice memo" src={src} controls/>
				</div>
			</div>
		)
		case 'video': return (
			<a href={src} target="_blank">
				<video className={styles.Attachment} controls>
					<source src={src}/>
				</video>
			</a>
		)
		default: return null
	}
}

const MediaSaveOptions = ({data})=>{
	const dispatch = useDispatch()
	const date = data.media_expires_on
	const now = new Date()
	const expire = new Date(date?.split(' ').join('T'))
	const diff = expire.getTime() - now.getTime()
	const seconds = Math.floor(diff/1000)
	const minutes = Math.floor(seconds/60)
	const hours = Math.floor(minutes/60)
	const days = Math.floor(hours/24)

	const getRemainingTimeString = ()=>{
		if (days) return `${days} day${days>1?'s':''}`
		if (hours) return `${hours} hour${hours>1?'s':''}`
		if (minutes) return `${minutes} minute${minutes>1?'s':''}`
		if (seconds) return `${seconds} second${seconds>1?'s':''}`
	}

	const handleToggleSaveMemo = ()=>{
		dispatch(toggleSaveMemo({
			message_id:data.id,
			room_id:data.room_id,
			save_memo:data.save_memo^1
		}))
	}

	return (
		<div className="d-flex justify-content-between">
			{Boolean(data.save_memo)&&
				<>
					<small className="text-muted">This memo has been saved and will not expire</small>
					<Button
						onClick={handleToggleSaveMemo}
						size="sm"
						variant="link"
						className="text-danger"
					>
						Unsave memo
					</Button>
				</>
			}
			{!Boolean(data.save_memo)&&
				<>
					<small className="text-muted">memo expires in {getRemainingTimeString()}</small>
					<Button
						onClick={handleToggleSaveMemo}
						size="sm"
						variant="link"
					>
						<i className="fa fa-save mr-1"/>
						Save memo
					</Button>
				</>
			}
		</div>
	)
}

const ReferenceSnippet = ({type,resource})=>{
	const dispatch = useDispatch()
	const handleCancel = ()=>{
		dispatch(setInReferenceToResource({
			type:'NONE',
			id:null,
			resource:null
		}))
	}
	const extractResourceTitle = ()=>{
		switch(type){
			case 'workout':
			case 'task':
			case 'nutrition': return resource.note
			default: return 'resource type not supported'
		}
	}
	return (
		<div className="text-info d-flex flex-wrap align-items-center mb-1">
			<small>Discussing {resourceTypeDisplayText(type)}</small>
			<button 
				onClick={handleCancel}
				style={{
					padding:'2px 6px',
					color:'red',
					border:'1px solid red',
					borderRadius:'5px',
					background:'none',
					marginLeft:'auto',
					fontSize:'12px'
				}}
			>
				See Full Chat
			</button>
		</div>
	)
}

const ActiveRoom = ()=>{
	const dispatch = useDispatch()
	const messagesRef = useRef()
	const user = useSelector(state=>state.users.current_user)
	const others = useSelector(selectOtherRoomMembers)
	const isClient = useSelector(state=>state.users.current_user.account_type === 'client')
	//trainers/gyms should only be allowed to schedule messages to clients 
	//in private chat rooms.
	const allowScheduling = (
		//private chat rooms only have one other
		others.length === 1 &&
		//other member is a client
		others[0].account_type === 'client'
	)
	const showMessageCenter = useSelector(selectShowMessageCenter)
	const {
		status,
		id,
		other,
		members,
		messages,
		owner_id,
		members_map,
		others:others_ids
	} = useSelector(selectActiveRoom)

	const inReferenceToResource = useSelector(selectInReferenceToResource)

	const [newMessage,setNewMessage] = useState('')
	const [scheduling,setScheduling] = useState(false)
	const [date,setDate] = useState(new Date())
	const [showRecorder,setShowRecorder] = useState(false)
	const [isLoadingMore,setIsLoadingMore] = useState(false)
	const [uploadPending,setUploadPending] = useState(false)
	const isTime24Hour = Number(useSelector(state => state.users.current_user.is_24_hour_time))

	//memo related state
	const [isMemo,setIsMemo] = useState(false)
	const [memo,setMemo] = useState(null)
	const [memoType,setMemoType] = useState(null)

	//store some additional state to handle the case that a user
	//reacts to a message & prevent auto scroll to bottom in this
	//case
	const [scrollState,setScrollState] = useState({
		numMessages:null,
		roomId:null
	})

	useEffect(()=>{
		if(
			!messagesRef.current || 
			isLoadingMore
		) return 
		//if a message was added scroll to bottom
		if(scrollState.numMessages < messages.length){
			messagesRef.current.scrollTop = messagesRef.current.scrollHeight
		}
		setScrollState({roomId:id,numMessages:messages.length})
	},[messages])

	//effects to run when a new room is selected
	useEffect(()=>{
		if ( status === 'pending' ) {
			setScrollState({numMessages:null,roomId:id})
		}
		//close voice memo 
		setShowRecorder(false)
	},[id,status])
	
	//effects to run when message center is opened/closed
	useEffect(()=>{
		setShowRecorder(false)
	},[showMessageCenter])

	const [uploadType,setUploadType] = useState(null)
	const [upload,setUpload] = useState(null)
	const {
		processUpload,
	} = useS3DirectUpload()

	const reactionsMap = useSelector( state => state.reactions.entities )
	const handleSend = async () => {
		const reactionsWithCount = {}
		Object.entries(reactionsMap).forEach(([k,v])=>{
			reactionsWithCount[k] = {...v,count:0}
		})
		const is_reference = Number(inReferenceToResource.type !== 'NONE')
		const reference_id = is_reference && inReferenceToResource.id 
		if(Boolean(memo)&&isMemo){
			dispatch(createChatMessage({
				media_type_id:memoType === 'voice' ? 4 : 1,
				attachment:URL.createObjectURL(memo),
				message:newMessage,
				author_id:user.user_id_number,
				transcode_memo_to_mp4:1,
				media_type:memoType,
				room_id:id,
				is_memo:1,
				is_reference,
				reference_id,
				reactions:{
					author_reaction_id:0,
					map:reactionsMap
				},
				memo,
			}))
		} else {
			const postData = {
				author_id:user.user_id_number,
				message:newMessage,
				room_id:id,
				is_reference,
				reference_id,
				reactions:{
					author_reaction_id:0,
					map:reactionsMap
				}
			}
			if (Boolean(upload)&&uploadType!=='video') {
				setUploadPending(true)
				const s3Res = await processUpload(upload)
				if (s3Res.success) {
					setUploadPending(false)
					postData.attachment = s3Res.payload.url
				}
			}
			if (Boolean(upload)&&uploadType==='video') {
				postData.video = upload
				postData.transcode_video_to_mp4 = 1
				postData.attachment = URL.createObjectURL(upload)
				postData.media_type_id = 1
				postData.media_type = 'video'
			}
			dispatch(createChatMessage(postData)).then(()=>{
				//need this here in the chance that user navigates
				//away from the chat center before everything loads
				//!!! IMPORTANT !!! need this check to prevent edge case crash
				if (!messagesRef.current) return
				messagesRef.current.scrollTop = messagesRef.current.scrollHeight
			})
		}
		setNewMessage('')
		handleClearAttachment()
	}

	const handleSchedule = async () => {
		const sent_at = dateToAPIStandard(date)
		const postData = {
			message:newMessage,
			recipients:others_ids,
			room_id:id,
			sent_at
		}
		if(Boolean(upload)){
			setUploadPending(true)
			const s3Res = await processUpload()
			if(s3Res.success){
				postData.attachment = s3Res.payload.url
				setUploadPending(false)
			}
		}
		setNewMessage('')
		setUpload(null)
		setScheduling(false)
		dispatch(scheduleMessage(postData)).then(()=>{
			messagesRef.current.scrollTop = messagesRef.current.scrollHeight
		})
	}

	const handleEmojiSelect = (e,emojiObject)=>{
		setNewMessage(`${newMessage} ${emojiObject.emoji}`)
	}

	const handleOpenMemoRecorder = (audio,video)=>{
		if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
			navigator.mediaDevices.getUserMedia(
				{audio,video}
			).then(stream=>{
				mediaStream = stream
				setShowRecorder(true)
			})
		}else{
			alert('Sorry, your browser does not support voice/video recording.')
		}
	}

	const handleToggleMemoRecorder = ()=>{
		dispatch(toggleShowMemoRecorder())
	}

	const handleClearAttachment = ()=>{
		setUpload(null)
		setIsMemo(false)
		setMemo(null)
		setMemoType(null)
	}

	const handleFinishMemo =  memoData => {
		handleClearAttachment()
		setIsMemo(true)
		setMemo(memoData.memo)
		setMemoType(memoData.type)
	}

	const handleDeleteChatRoomMessage = id => {
		if(!window.confirm('Are you sure you want to delete this message?')) return
		dispatch(deleteChatRoomMessage(id))
	}

	let timeStampGroupStart = false
	let currentSender = false
	return (
		<div className={styles.ActiveRoom}>

			{
				status === 'pending' ?
				<CenteredLoader/>:
				(
					Boolean(id)?
					<div className={styles.Feed}>
						<Members/>
						<MemoRecorder handleFinish={handleFinishMemo}/>
						<div ref={messagesRef} className={styles.Messages}>
							{(messages.length > 0) &&
								<LoadMoreMessages
									setIsLoadingMore={setIsLoadingMore}
									variant="outline-primary"
									room_id={id}
								/>
							}
							{
								messages.length > 0 ?
								messages.map( messageData => {
									if(messageData.is_resource_reference){
										return <ResourceReference resourceReference={messageData}/>
									}
									const authorData = members_map[messageData.author_id]
									//in the off chance that data is returned from api (especially legacy calls)
									//that contains messages from a non-member then return null
									if(!authorData) return null
									const showSender = messageData.author_id !== currentSender
									currentSender = messageData.author_id
									const showTimeStamp = (
										!timeStampGroupStart ||
										!newTimeInRange(timeStampGroupStart,messageData.sent_at.replace(/-/g, "/"))
									)
									const showHeader = showSender || showTimeStamp
									timeStampGroupStart = (
										showTimeStamp?
										messageData.sent_at.replace(/-/g, "/"):
										timeStampGroupStart
									)
									const valid_sent_at = messageData.sent_at?.split(' ').join('T')
									const formattedDateTime = (new Date(valid_sent_at)).toLocaleString([],{
										// isTime24Hour should be false for 12 hour clock
										hour12: !isTime24Hour,
										year: 'numeric', month: 'short', day: 'numeric',
										hour: '2-digit', minute:'2-digit'
									})
									return (
										<div key={messageData.id} className="d-flex mb-1">
											{
												showSender?
												(
													Boolean(authorData.profile_pic)?
													<img 
														onError={e=>{
															e.target.src="https://cdn.fitsw.com/assets/img/defaultProfile.png"
														}}
														style={{
															borderRadius:'100%',
															width:'32px',
															height:'32px',
															objectFit:'cover'
														}} 
														src={authorData.profile_pic}
													/>
													:
													<div 
														className="d-flex align-items-center justify-content-center"
														style={{
															borderRadius:'100%',
															width:'32px',
															height:'32px',
															background:'#338eff',
															display:'inline-block',
															flex:'0 0 auto'
														}}
													>
														{capitalize(authorData.user_name.charAt(0))}
													</div>
												):
												<div style={{width:'32px',flex:'0 0 auto'}}/>
											}
											<div className="ml-1" style={{flex:'1 1 auto'}}>
												<div>
													{showSender&&
														<span className="mr-1" style={{fontSize:'14px',fontWeight:'600'}}>
															{authorData.user_name}
														</span>
													}
													{showTimeStamp&&
														<small className="text-muted">
															{formattedDateTime}
														</small>
													}
												</div>
												<div className={[
													styles.Message,
													messageData.author_id == user.user_id_number&&styles.Author
												].join(' ')}>
													{messageData.author_id == user.user_id_number&&
														<OverlayTrigger overlay={
															<Tooltip>Delete this message</Tooltip>
														}>
															<button 
																onClick={handleDeleteChatRoomMessage.bind(null,messageData.id)}
																className={styles.Delete}
															>
																<i className="fa fa-times"/>
															</button>
														</OverlayTrigger>
													}
													{Boolean(messageData.attachment)&&
														<Attachment 
															mediaType={messageData.media_type}
															src={messageData.attachment}
															removed={Boolean(messageData.media_removed)}
														/>
													}
													{(Boolean(messageData.media_expires_on)&&!messageData.media_removed)&&
														<MediaSaveOptions data={messageData}/>
													}
													<Linkify componentDecorator={linkDecorator}>
														{messageData.message}
													</Linkify>
													{
														checkHasReactions(messageData.reactions.map)?
														<div>
															<Reactions 
																onReaction={ reaction => {
																	dispatch(reactToChatMessage({
																		message_id:messageData.id,
																		reaction_id:reaction.id,
																		room_id:messageData.room_id,
																		user_id_number:user.user_id_number
																	}))
																}} 
																reactions={messageData.reactions.map}
																onlyShowTotals={true}
															/>
														</div>
														:
														<div className={styles.Reactions}>
															<Reactions 
																onReaction={ reaction => {
																	dispatch(reactToChatMessage({
																		message_id:messageData.id,
																		reaction_id:reaction.id,
																		room_id:messageData.room_id,
																		user_id_number:user.user_id_number
																	}))
																}} 
																reactions={messageData.reactions.map}
															/>
														</div>
													}
												</div>
											</div>
										</div>
									)//end message JSX
								})//end messages.map
								:
								<div 
									className="d-flex align-items-center justify-content-center flex-column"
									style={{height:'100%'}}
								>
									No messages yet
								</div>
							}
						</div>
						<div className={styles.Editor}>
							{inReferenceToResource.type!=='NONE'&&
								<ReferenceSnippet
									type={inReferenceToResource.type}
									resource={inReferenceToResource.resource}
								/>
							}
							<div className="d-flex">
								{Boolean(upload)&&
									<div className={styles.MediaPreview}>
										{uploadType==='video'
											? <video src={URL.createObjectURL(upload)}/>
											: <img src={URL.createObjectURL(upload)}/>
										}
										<Button 
											variant="link"
											className="text-danger"
											size="sm"
											block
											onClick={handleClearAttachment} 
											tabIndex={0}
										>
											remove
										</Button>
									</div>
								}
								{(isMemo&&Boolean(memo))&&
									<div className={styles.MediaPreview}>
										<video controls src={URL.createObjectURL(memo)}/>
										<Button 
											variant="link"
											className="text-danger"
											size="sm"
											block
											onClick={handleClearAttachment} 
											tabIndex={0}
										>
											remove
										</Button>
									</div>
								}
								<Form.Control 
									className={inReferenceToResource.type!=='NONE'?'border-info':''}
									onChange={e=>{
										setNewMessage(e.target.value)
									}}
									onKeyDown={e=>{
										//handle hot keys
										if (e.key==='Enter'&&!e.shiftKey) {
											handleSend()
											e.preventDefault()
										}
									}}
									value={newMessage}
									as="textarea" 
									style={{resize:'none'}}
								/>
							</div>
							<div>
								<small className="text-muted">Enter to send, Shift+Enter for new line</small>
							</div>
							<div className="d-flex justify-content-end mt-1">
								<OverlayTrigger overlay={
									<Tooltip>
										Record a voice/video memo
									</Tooltip>
								}>
									<Button 
										className="text-dark"
										onClick={handleToggleMemoRecorder}
										disabled={status ===  'loading'} 
										variant="link"
									>
										<i className="fa fa-microphone"/> / <i className="fa fa-video"/>
									</Button>
								</OverlayTrigger>
								<OverlayTrigger trigger="click" overlay={
									<Popover>
										<EmojiPicker onEmojiClick={handleEmojiSelect}/>
									</Popover>
								}>
									<Button variant="link" className="text-secondary">
										<i className="far fa-laugh"/>
									</Button>
								</OverlayTrigger>
								<OverlayTrigger overlay={
									<Tooltip>
										Add Attachment
									</Tooltip>
								}>
									<span>
										<FileButton
											disabled={uploadPending}
											onChange={e=>{
												const file = e.target.files[0]
												//20mb
												const maxSize = 40000000
												if (file.size >= maxSize) {
													window.alert('That file is too big. The max size is 40mb')
													return
												}
												const isVideo = file.type.split('/')[0] === 'video'
												setUploadType(isVideo?'video':'image')
												setUpload(file)
											}}
										/>
									</span>
								</OverlayTrigger>
								{(!isClient&&allowScheduling)&&
									<OverlayTrigger overlay={
										<Tooltip>
											{scheduling?"Cancel":'Schedule'}
										</Tooltip>
									}>
										<Button 
											variant="link" 
											className={
												scheduling ?
												"text-danger" :
												"text-info"
											}
											onClick={()=>{
												setScheduling(!scheduling)
											}}
										>
											<i className={
												scheduling ?
												"fa fa-times":
												"fas fa-calendar"
											}/>
										</Button>
									</OverlayTrigger>
								}
								{
									scheduling&&
									<DatePicker
										onChangeRaw={e=>{e.preventDefault()}}
										selected={date}
										onChange={date=>setDate(date)}
										showTimeSelect
										timeIntervals={15}
										dateFormat="MMM d, yy @ h:mm aa"
										minDate={new Date()}
										popperModifiers={{
											preventOverflow: {
												enabled: true,
												escapeWithReference: false,
												boundariesElement: 'viewport'
											}
										}}
										popperProps={{
											positionFixed: true
										}}
										customInput={<Form.Control/>}/>
								}
								<Button 
									disabled={(!newMessage&&!upload&&!memo)||uploadPending}
									onClick={scheduling?handleSchedule:handleSend}
									variant="link" 
									className={
										!newMessage&&!upload&&!memo?
										"text-secondary":
										"text-success"
									}
								>
									{
										uploadPending ?
										<span>
											Saving attachment <Spinner animation="border" size="sm"/>
										</span>
										:
										<i className={
											scheduling ?
											"fas fa-save" :
											"far fa-paper-plane"
										}/>
									}
								</Button>
							</div>
						</div>
					</div>
					:
					<div 
						style={{height:'100%'}} 
						className="d-flex justify-content-center align-items-center"
					>
						No room selected
					</div>
				)
			}
		</div>
	)
}

export default ActiveRoom